import { ALLOWED_FILE_TYPES } from 'AgentApp/ts/constants/agent-file.constants';
export const isAllowedFileType = (file) => {
    const name = file.name.toLowerCase();
    const mimeType = file.type.toLowerCase();
    return ALLOWED_FILE_TYPES.some((allowed) => {
        if (allowed.endsWith('/*')) {
            const prefix = allowed.slice(0, -1); // e.g. "image/"
            return mimeType.startsWith(prefix);
        }
        if (allowed.startsWith('.')) {
            return name.endsWith(allowed.toLowerCase());
        }
        return mimeType === allowed.toLowerCase();
    });
};
